// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import utils from '../../utils/utils';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const PATH = 'workouts';
const navigateTo = '/workout';

const initialState = {
    workouts: [],
    workoutsObject: {},
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'workouts',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getSuccess(state, action) {
            const data = action.payload.data;
            state.workouts = data;
            const total = action.payload.totalItems;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },

        getSuccessWithLoading(state, action) {
            const data = action.payload.data;
            state.workouts = data;
            const total = action.payload.totalItems;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = true;
        },

        addSuccess(state, action) {
            state.loading = false;
        },
        editSuccess(state, action) {
            state.loading = false;
        },
        deleteSuccess(state, action) {
            state.loading = false;
            state.workouts = state.workouts.filter((item) => item.id !== action.payload.id);
        },
        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

export function getWorkout(offset = 0, featured = false, featured2 = false, params = "") {
    return async () => {
        dispatch(slice.actions.getSuccessWithLoading({ totalPages: 0, totalItems: 0, data: [], currentPage: 0 }));
        const URL = `/workouts?size=999999&offset=` + offset + `&featured=${featured}&featured2=${featured2}&${params}`;
        try {
            const result = await axios.get(URL);
            console.log('RES [getWorkout]:', result.data);
            dispatch(slice.actions.getSuccess(result.data));
        } catch (error) {
            console.log('ERR [getWorkout]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addWorkout(data, navigate, callback = () => {}, errCallback = () => {}) {
    return async () => {
        try {
            const result = await axios.post(`/workouts`, data);
            console.log('RES [addWorkout] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
            callback();
        } catch (error) {
            errCallback();
            console.log('ERR [addWorkout] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editWorkout(id, data, navigate, callback = () => {}, errCallback = () => {}) {
    return async () => {
        const URL = `/workouts/${id}`;
        try {
            const result = await axios.put(URL, data);
            console.log('RES [editWorkout] =======> ', result?.data?.data);
            dispatch(slice.actions.editSuccess(result?.data?.data));
            callback();
        } catch (error) {
            errCallback();
            console.log('ERR [editWorkout] ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteWorkout(id = '', callback = () => {}, errCallback = () => {}) {
    return async () => {
        try {
            const result = await axios.delete(`/workouts/${id}`);
            console.log('RES [deleteWorkout] =======> ', result);
            dispatch(slice.actions.deleteSuccess(result));
            callback();
        } catch (error) {
            console.log('ERR [deleteWorkout] =========> ', error);
            dispatch(slice.actions.hasError(error));
            errCallback();
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
